// src/store/actions/serviceActions.js
import { SERVICE_ACTIONS } from './actionTypes';
import serviceService from '../../services/serviceService';

// Fetch services
export const fetchServices = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.FETCH_SERVICES_REQUEST });

    const response = await serviceService.getServices(params);
    
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICES_FAILURE,
      payload: error.message || 'Failed to fetch services',
    });
  }
};

// Fetch single service
export const fetchService = (id) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.FETCH_SERVICE_REQUEST });

    const response = await serviceService.getServiceById(id);
    
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_FAILURE,
      payload: error.message || 'Failed to fetch service',
    });
    throw error;
  }
};

// Create service
export const createService = (serviceData) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.CREATE_SERVICE_REQUEST });

    const response = await serviceService.createService(serviceData);
    
    dispatch({
      type: SERVICE_ACTIONS.CREATE_SERVICE_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.CREATE_SERVICE_FAILURE,
      payload: error.message || 'Failed to create service',
    });
    throw error;
  }
};

// Update service
export const updateService = (id, serviceData) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.UPDATE_SERVICE_REQUEST });

    const response = await serviceService.updateService(id, serviceData);
    
    dispatch({
      type: SERVICE_ACTIONS.UPDATE_SERVICE_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.UPDATE_SERVICE_FAILURE,
      payload: error.message || 'Failed to update service',
    });
    throw error;
  }
};

// Delete service
export const deleteService = (id) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.DELETE_SERVICE_REQUEST });

    const response = await serviceService.deleteService(id);
    
    dispatch({
      type: SERVICE_ACTIONS.DELETE_SERVICE_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.DELETE_SERVICE_FAILURE,
      payload: error.message || 'Failed to delete service',
    });
    throw error;
  }
};

// Toggle service status
export const toggleServiceStatus = (id) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.TOGGLE_SERVICE_STATUS_REQUEST });

    const response = await serviceService.toggleServiceStatus(id);
    
    dispatch({
      type: SERVICE_ACTIONS.TOGGLE_SERVICE_STATUS_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.TOGGLE_SERVICE_STATUS_FAILURE,
      payload: error.message || 'Failed to toggle service status',
    });
    throw error;
  }
};

// Get service agencies
export const fetchServiceAgencies = (serviceId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.FETCH_SERVICE_AGENCIES_REQUEST });

    const response = await serviceService.getServiceAgencies(serviceId, params);
    
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_AGENCIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_AGENCIES_FAILURE,
      payload: error.message || 'Failed to fetch service agencies',
    });
  }
};

// Bulk delete services
export const bulkDeleteServices = (ids) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.BULK_DELETE_SERVICES_REQUEST });

    const response = await serviceService.bulkDeleteServices(ids);
    
    dispatch({
      type: SERVICE_ACTIONS.BULK_DELETE_SERVICES_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.BULK_DELETE_SERVICES_FAILURE,
      payload: error.message || 'Failed to bulk delete services',
    });
    throw error;
  }
};

// Get popular services
export const fetchPopularServices = (limit = 10) => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.FETCH_POPULAR_SERVICES_REQUEST });

    const response = await serviceService.getPopularServices(limit);
    
    dispatch({
      type: SERVICE_ACTIONS.FETCH_POPULAR_SERVICES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.FETCH_POPULAR_SERVICES_FAILURE,
      payload: error.message || 'Failed to fetch popular services',
    });
  }
};

// Get service statistics
export const fetchServiceStats = () => async (dispatch) => {
  try {
    dispatch({ type: SERVICE_ACTIONS.FETCH_SERVICE_STATS_REQUEST });

    const response = await serviceService.getServiceStats();
    
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_STATS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: SERVICE_ACTIONS.FETCH_SERVICE_STATS_FAILURE,
      payload: error.message || 'Failed to fetch service statistics',
    });
  }
};


// Set service filters
export const setServiceFilters = (filters) => ({
  type: SERVICE_ACTIONS.SET_SERVICE_FILTERS,
  payload: filters,
});

// Clear error
export const clearServiceError = () => ({
  type: SERVICE_ACTIONS.CLEAR_SERVICE_ERROR,
});

// Clear success
export const clearServiceSuccess = () => ({
  type: SERVICE_ACTIONS.CLEAR_SERVICE_SUCCESS,
});

// Clear selected service
export const clearSelectedService = () => ({
  type: SERVICE_ACTIONS.CLEAR_SELECTED_SERVICE,
});